var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var Fifo = require('fast-fifo');

var defer = require('p-defer');

module.exports = /*#__PURE__*/function () {
  "use strict";

  function PFifo() {
    _classCallCheck(this, PFifo);

    this._buffer = new Fifo();
    this._waitingConsumers = new Fifo();
  }

  _createClass(PFifo, [{
    key: "push",
    value: function push(chunk) {
      var _defer = defer(),
          promise = _defer.promise,
          resolve = _defer.resolve;

      this._buffer.push({
        chunk: chunk,
        resolve: resolve
      });

      this._consume();

      return promise;
    }
  }, {
    key: "_consume",
    value: function _consume() {
      while (!this._waitingConsumers.isEmpty() && !this._buffer.isEmpty()) {
        var nextConsumer = this._waitingConsumers.shift();

        var nextChunk = this._buffer.shift();

        nextConsumer.resolve(nextChunk.chunk);
        nextChunk.resolve();
      }
    }
  }, {
    key: "shift",
    value: function shift() {
      var _defer2 = defer(),
          promise = _defer2.promise,
          resolve = _defer2.resolve;

      this._waitingConsumers.push({
        resolve: resolve
      });

      this._consume();

      return promise;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._buffer.isEmpty();
    }
  }]);

  return PFifo;
}();